import React, { useState } from 'react';
import { Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import { AddButton } from '../../components/common/button/CustomButtons';
import ChildHeader from '../../components/ui/ChildHeader';
import { SearchFilterContainer } from '../../assets/styles/layout/searchFilter.styled';
import FilterBy from '../../components/common/FilterBy';
import { SearchBar } from '../../components/common/SearchBar';
import { CustomPagination, TableCustom } from '../../components/common';
import useDebounce from '../../hooks/useDebounce';
import {
  EditIconButton,
  DeleteIconButton,
  ViewIconButton,
  ListIconButton,
} from '../../components/common/button/CustomIconButton';
import Create from './Create';
import ModalCustom from '../../components/common/Modal';
import { useQuery } from '../../hooks/UseQuery';
import useConfirm from '../../components/common/useConfirm';
import { IData } from './helpers/interfaces';
import ViewFile from './components/ViewFile';
import TextAreaInput from '../../components/common/TextAreaInput';

const tableHeaderObj = [
  [
    { text: 'S.NO.', rowspan: 1, colspan: 1 },
    { text: 'USER ID', rowspan: 1, colspan: 1 },
    { text: 'DATE OF SUBMISSION', rowspan: 1, colspan: 1 },
    { text: 'DESCRIPTION', rowspan: 1, colspan: 1 },
    { text: 'Benefit to the Company', rowspan: 1, colspan: 1 },
    { text: 'KAIZEN REMARKS', rowspan: 1, colspan: 1 },
    // { text: 'CLOSED BY', rowspan: 1, colspan: 1 },

    // { text: 'CLOSURE DATE', rowspan: 1, colspan: 1 },
    { text: 'STATUS', rowspan: 1, colspan: 1 },
    { text: 'ACTION', rowspan: 1, colspan: 1 },
  ],
];

const sortOptions = [
  { value: 'user_id', name: 'A-Z' },
  { value: 'createdAt', name: 'Most Recent First' },
  { value: 'createdAt_old', name: 'Oldest First' },
];
const filterOptions = [
  { value: 'Pending', name: 'Pending' },
  { value: 'Send Back For Improvement', name: 'Send Back For Improvement' },
  { value: 'Approve', name: 'Approve' },
];

const List = () => {
  const [data, setData] = useState<IData[]>([]);
  const [isModal, setIsModal] = useState<boolean>(false);
  const [render, setRender] = useState(false);
  const [complaintId, setComplaintId] = useState<string | null>(null);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);
  const [id, setId] = useState<string | null>(null);
  const [isFileOpenPopup, setIsFileOpenPopup] = useState(false);
  const [isDisable, setDisable] = useState(false);
  const search = useQuery('search') || '';
  const sort = useQuery('sort') || 'createdAt';
  const filter = useQuery('filter') || '';
  const page = useQuery('page') || 1;

  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE',
    'Are you sure you want to delete this?'
  );

  const fetchData = async () => {
    const res = await axios
      .get(
        `/api/kaizenSubmission/?page=${page}&sortBy=${sort}&filterBy=${filter}&search=${search}&perPage=${perPage}`
      )
      .catch((err) => {
        console.log(err);
      });
    setData(res?.data?.results);
    setPerPage(res?.data?.perPage);
    setTotalPages(res?.data?.pages);
  };

  const deleteCustomer = async (id: string) => {
    const ans = await confirmDelete();
    if (!ans) return;
    await axios
      .delete(`/api/kaizenSubmission/${id}`)
      .then((res) => {
        alert('Document deleted successfully');
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  useDebounce(fetchData, 500, [page, search, render, isModal, sort, filter]);

  return (
    <>
      <ChildHeader text="KAIZEN SUBMISSION">
        <AddButton onClick={() => setIsModal(true)} label="ADD KAIZEN" />
      </ChildHeader>
      <SearchFilterContainer filter={true} style={{ display: 'flex' }}>
        <SearchBar label="Search By User" sx={{ width: 800 }} />
        {/* <Stack direction={'row'} gap={2} flex="1"> */}
        <FilterBy sx={{ width: 400 }} options={filterOptions} />
        <FilterBy
          name="sort"
          label="Sort By"
          sx={{ width: 200 }}
          options={sortOptions}
        />
        {/* </Stack> */}
      </SearchFilterContainer>
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {data &&
            data.map((item: IData, index: number) => (
              <React.Fragment key={item._id}>
                <TableRow>
                  <TableCell align="center">
                    {perPage * (+page - 1) + index + 1}
                  </TableCell>
                  <TableCell align="center">{item?.user_id}</TableCell>
                  <TableCell align="center">
                    {item?.date_of_submission}
                  </TableCell>
                  <TableCell align="center">
                    <TextAreaInput disabled={true} value={item?.description} />
                  </TableCell>
                  <TableCell align="center">
                    <TextAreaInput disabled={true} value={item?.benefit} />
                  </TableCell>
                  <TableCell align="center">
                    <TextAreaInput
                      disabled={true}
                      value={item?.kaizen_remarks}
                    />
                  </TableCell>
                  {/* <TableCell align="center">{item?.closed_by}</TableCell>

                  <TableCell align="center">{item?.closure_date}</TableCell> */}
                  <TableCell
                    style={{
                      background:
                        item?.status === 'Approve'
                          ? 'green'
                          : item?.status === 'Pending'
                          ? 'red'
                          : item?.status === 'Send Back for Improvement'
                          ? 'orange'
                          : 'yellow',
                    }}
                    align="center"
                  >
                    {item?.status}
                  </TableCell>
                  <TableCell>
                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                      <ListIconButton
                        tooltipTitle="FILE LIST"
                        onClick={() => {
                          setId(item._id || null);
                          setIsFileOpenPopup(true);
                        }}
                      />
                      <ViewIconButton
                        tooltipTitle="VIEW"
                        onClick={() => {
                          setComplaintId(item?._id || '');
                          setDisable(true);
                          setIsModal(true);
                        }}
                      />
                      <EditIconButton
                        tooltipTitle="EDIT"
                        onClick={() => {
                          setComplaintId(item?._id || '');
                          setDisable(false);
                          setIsModal(true);
                        }}
                      />

                      <DeleteIconButton
                        tooltipTitle="DELETE"
                        onClick={() => {
                          deleteCustomer(item?._id || '');
                        }}
                      />
                    </Stack>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>
      <CustomPagination totalPage={totalPages} />
      <ModalCustom
        openModal={isModal}
        closeModal={() => {
          setComplaintId(null);
          setIsModal(false);
        }}
        title="KAIZEN SUBMISSION"
      >
        <Create id={complaintId} setIsModal={setIsModal} disable={isDisable} />
      </ModalCustom>
      <ModalCustom
        title="FILE LIST"
        openModal={isFileOpenPopup}
        closeModal={() => {
          setId(null);
          setIsFileOpenPopup(false);
        }}
      >
        <ViewFile id={id} />
      </ModalCustom>
      <DialogDelete isSubmitContent={false} />
    </>
  );
};

export default List;
